// Registre Stimulus du pack `www` (site vitrine, #16078). Contrairement à index.js, aucun
// chargement automatique : seuls les contrôleurs des pages du vitrine partent dans le pack.
// spec/config/www_stimulus_controllers_spec.rb échoue si une vue du vitrine utilise un
// contrôleur absent d'ici.

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import Accordion__ComponentController from "components/accordion/component_controller"
application.register("accordion--component", Accordion__ComponentController)

import Alert__ComponentController from "components/alert/component_controller"
application.register("alert--component", Alert__ComponentController)

import AppContactFormController from "./app_contact_form_controller"
application.register("app-contact-form", AppContactFormController)

import Burger__ComponentController from "components/burger/component_controller"
application.register("burger--component", Burger__ComponentController)

import CatalogSearchController from "./catalog_search_controller"
application.register("catalog-search", CatalogSearchController)

import CatalogSearchListController from "./catalog_search_list_controller"
application.register("catalog-search-list", CatalogSearchListController)

import Clipboard__ComponentController from "components/clipboard/component_controller"
application.register("clipboard--component", Clipboard__ComponentController)

import Concerns__DialogConfirmableController from "components/concerns/dialog_confirmable_controller"
application.register("concerns--dialog-confirmable", Concerns__DialogConfirmableController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import ContactTabsController from "./contact_tabs_controller"
application.register("contact-tabs", ContactTabsController)

import Dropdown__ComponentController from "components/dropdown/component_controller"
application.register("dropdown--component", Dropdown__ComponentController)

import Form__AddressField__ComponentController from "components/form/address_field/component_controller"
application.register("form--address-field--component", Form__AddressField__ComponentController)

import Form__CodeField__ComponentController from "components/form/code_field/component_controller"
application.register("form--code-field--component", Form__CodeField__ComponentController)

import Form__CollectionCheckButtons__ComponentController from "components/form/collection_check_buttons/component_controller"
application.register("form--collection-check-buttons--component", Form__CollectionCheckButtons__ComponentController)

import Form__CollectionSelect__ComponentController from "components/form/collection_select/component_controller"
application.register("form--collection-select--component", Form__CollectionSelect__ComponentController)

import Form__ComponentController from "components/form/component_controller"
application.register("form--component", Form__ComponentController)

import Form__CounterField__ComponentController from "components/form/counter_field/component_controller"
application.register("form--counter-field--component", Form__CounterField__ComponentController)

import Form__EventField__ComponentController from "components/form/event_field/component_controller"
application.register("form--event-field--component", Form__EventField__ComponentController)

import Form__FieldsFor__ComponentController from "components/form/fields_for/component_controller"
application.register("form--fields-for--component", Form__FieldsFor__ComponentController)

import Form__FileField__ComponentController from "components/form/file_field/component_controller"
application.register("form--file-field--component", Form__FileField__ComponentController)

import Form__IbanField__ComponentController from "components/form/iban_field/component_controller"
application.register("form--iban-field--component", Form__IbanField__ComponentController)

import Form__IconField__ComponentController from "components/form/icon_field/component_controller"
application.register("form--icon-field--component", Form__IconField__ComponentController)

import Form__PhoneField__ComponentController from "components/form/phone_field/component_controller"
application.register("form--phone-field--component", Form__PhoneField__ComponentController)

import Form__Range__ComponentController from "components/form/range/component_controller"
application.register("form--range--component", Form__Range__ComponentController)

import Form__Slider__ComponentController from "components/form/slider/component_controller"
application.register("form--slider--component", Form__Slider__ComponentController)

import Form__TextArea__ComponentController from "components/form/text_area/component_controller"
application.register("form--text-area--component", Form__TextArea__ComponentController)

import Form__TextField__ComponentController from "components/form/text_field/component_controller"
application.register("form--text-field--component", Form__TextField__ComponentController)

import Form__ToggleField__ComponentController from "components/form/toggle_field/component_controller"
application.register("form--toggle-field--component", Form__ToggleField__ComponentController)

import Gallery__ComponentController from "components/gallery/component_controller"
application.register("gallery--component", Gallery__ComponentController)

import HelpCenterFeedbackController from "./help_center_feedback_controller"
application.register("help-center-feedback", HelpCenterFeedbackController)

import HomeHeaderVideoController from "./home_header_video_controller"
application.register("home-header-video", HomeHeaderVideoController)

import HotkeysController from "stimulus-hotkeys"
application.register("hotkeys", HotkeysController)

import LazyRecaptchaController from "./lazy_recaptcha_controller"
application.register("lazy-recaptcha", LazyRecaptchaController)

import Map__ComponentController from "components/map/component_controller"
application.register("map--component", Map__ComponentController)

import MapAutocomplete__ComponentController from "components/map_autocomplete/component_controller"
application.register("map-autocomplete--component", MapAutocomplete__ComponentController)

import Modal__ComponentController from "components/modal/component_controller"
application.register("modal--component", Modal__ComponentController)

import ModalCloseController from "./modal_close_controller"
application.register("modal-close", ModalCloseController)

import Navbar__ComponentController from "components/navbar/component_controller"
application.register("navbar--component", Navbar__ComponentController)

import OqoroStripe__PaymentIntent__ComponentController from "components/oqoro_stripe/payment_intent/component_controller"
application.register("oqoro-stripe--payment-intent--component", OqoroStripe__PaymentIntent__ComponentController)

import PasswordCheckController from "./password_check_controller"
application.register("password-check", PasswordCheckController)

import PlusProcessController from "./plus_process_controller"
application.register("plus-process", PlusProcessController)

import Scroller__ComponentController from "components/scroller/component_controller"
application.register("scroller--component", Scroller__ComponentController)

import SlideOver__ComponentController from "components/slide_over/component_controller"
application.register("slide-over--component", SlideOver__ComponentController)

import Slider__ComponentController from "components/slider/component_controller"
application.register("slider--component", Slider__ComponentController)

import SoloRedirectModalController from "./solo_redirect_modal_controller"
application.register("solo-redirect-modal", SoloRedirectModalController)

import Tab__ComponentController from "components/tab/component_controller"
application.register("tab--component", Tab__ComponentController)

import ToolsGenerateurController from "./tools_generateur_controller"
application.register("tools-generateur", ToolsGenerateurController)
